import React from 'react';
export var defaultState = {
  signedIn: false,
  requiresAuth: null
};
export var BridgeContext = /*#__PURE__*/React.createContext(defaultState);
BridgeContext.displayName = 'Bridge';
export default BridgeContext;
//# sourceMappingURL=context.js.map